import { useState } from "react";

import { ScrollView, View } from "react-native";
import { Button, Divider } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import DeliveryModeEnabledSwitch from "./DeliveryModeEnabledSwitch";
import DisabledFulfillments from "./DisabledFulfillments";
import FulfillmentOptions from "./FulfillmentOptions";
import InfoModal from "./InfoModal";
import InfoText from "./InfoText";
import PickupInfo from "./PickupInfo";
import useDeliveryFulfillments from "../../contexts/DeliveryFulfillmentsContext";
import {
  DeliveryFulfillmentsScreenProps,
  deliveryFulfillmentsRoutes,
} from "../../navigation/types";

type ScreenProps = DeliveryFulfillmentsScreenProps<
  typeof deliveryFulfillmentsRoutes.automaticFulfillments
>;
export default function AutomaticFulfillmentsScreen({
  navigation,
}: ScreenProps) {
  const tailwind = useTailwind();

  const { automaticFulfillmentsEnabled, updateAutomaticFulfillmentEnabled } =
    useDeliveryFulfillments();

  const [modalVisible, setModalVisible] = useState(false);

  function navigateToPickupLocation() {
    navigation.navigate(deliveryFulfillmentsRoutes.pickupLocation);
  }

  return (
    <ScrollView
      contentContainerStyle={tailwind("mx-4 py-4 gap-4")}
      bounces={false}
    >
      <InfoModal
        visible={modalVisible}
        onDismiss={() => setModalVisible(false)}
      />

      <DeliveryModeEnabledSwitch
        enabled={automaticFulfillmentsEnabled}
        onChange={updateAutomaticFulfillmentEnabled}
      />

      <Button
        mode="text"
        onPress={() => setModalVisible(true)}
        style={tailwind("self-start")}
      >
        Ver mas info
      </Button>

      <Divider />

      {automaticFulfillmentsEnabled ? (
        <View style={tailwind("gap-4")}>
          <InfoText
            title="Direccion de recogida"
            details="Detalla la dirección donde deseas que recojan los pedidos por enviar."
          />

          <PickupInfo navigateToPickupLocation={navigateToPickupLocation} />

          <Divider />

          <FulfillmentOptions />
        </View>
      ) : (
        <DisabledFulfillments />
      )}
    </ScrollView>
  );
}
